import {
  PIPEFITTER_RANDOM_COMPAT_RESET,
  PIPEFITTER_RANDOM_COMPAT_SET_STATE,
} from './types';

const initialState = {
  /** idle | submitting | working | done | failed */
  phase: 'idle',
  jobId: null,
  estimatedRuns: null,
  progress: null,
  /** Last lot-phase progress snapshot — kept when withoutThem/shortlist overwrite `progress`. */
  lotProgress: null,
  /** Last withoutThem-phase snapshot — kept when shortlist overwrites `progress` (Step 5 statement). */
  withoutThemProgress: null,
  /** True once progress.phase was "withoutThem" this job (for step numbering). */
  withoutThemSeen: false,
  result: null,
  reason: null,
  error: null,
  lastRequest: null,
};

export default function pipefitterRandomCompatReducer(state = initialState, action) {
  switch (action.type) {
    case PIPEFITTER_RANDOM_COMPAT_RESET:
      return { ...initialState };
    case PIPEFITTER_RANDOM_COMPAT_SET_STATE: {
      const payload = action.payload || {};
      const next = { ...state, ...payload };

      // New submit clears lot snapshot and phase flags.
      if (payload.phase === 'submitting') {
        next.lotProgress = null;
        next.withoutThemProgress = null;
        next.withoutThemSeen = false;
      }

      const p = payload.progress;
      if (p && typeof p === 'object') {
        // Only lot-phase numbers feed Steps 1–4 (PRD: withoutThem/shortlist overwrite progress).
        if (p.phase == null || p.phase === 'lot') {
          next.lotProgress = p;
        }
        if (p.phase === 'withoutThem') {
          next.withoutThemSeen = true;
          next.withoutThemProgress = p;
        }
      }

      // Finished report with dead ends also marks the phase as having occurred.
      if (payload.result?.weldability?.deadEnds) {
        next.withoutThemSeen = true;
      }

      return next;
    }
    default:
      return state;
  }
}

export { initialState as randomCompatInitialState };
